<template>
  <v-navigation-drawer class="custom-scrollbars" :model-value="!!(store.drawerItems[props.id] && store.drawerItems[props.id].showDrawer)" 
    location="bottom" :scrim="false" temporary style="max-height: 70vh; overflow-y: auto;">
    <v-layout class="help-panel-content flex-column" style="padding-left: 50px; padding-right: 50px;">
      <div style="width: 100%;" class="d-flex justify-space-between">
        <AnimatedButton icon="ecc:ecc-T-Help" label="Need help?"></AnimatedButton>
        <AnimatedButton icon="ecc:ecc-M-Chiudi" label="Close" @click="store.drawerItems[props.id]?.toggle"></AnimatedButton>
      </div>
      <br />
      <div style="width: 100%;">
        <slot></slot>
      </div>
    </v-layout>
  </v-navigation-drawer>
</template>

<script setup lang="ts">
import { store } from './Help.store';
import AnimatedButton from '../../components/UIComponents/AnimatedButton.vue';

const props = defineProps<{
  id: string;
}>();
</script>